
import { DealernetApi } from "./DealernetApi";
export class LoginService {  

  public static async getIsLoggedIn(): Promise<any> {
      const response = await DealernetApi.client().request({
          method: "get",
          url: "/is-logged-in"
      });
      return response.data;
  }
}